module.exports = __webpack_public_path__ + "static/media/工程咨询甲级资信-建筑、农林业、电力、电子、石化等.2bf4d43d.png";